import StocktakeList from './StocktakeList';
export default StocktakeList;
